import join from 'url-join';

import { TargetDomain } from '../types';
import { clearTokens, getJwt, getRefreshToken, setJwt } from './tokens';

export async function refreshJwt(
  authHost: string,
  targetDomain: TargetDomain,
): Promise<string | undefined> {
  const refreshToken = getRefreshToken();

  if (refreshToken == null) {
    console.error('Did not find a refresh token in local storage');
    return;
  }

  if (refreshToken === 'impersonation-placeholder') {
    console.warn('Impersonation placeholder token, not refreshing');
    return;
  }

  const res = await fetch(join(authHost, '/v1/refresh', refreshToken), {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${getJwt()}`, // refresh accepts the old Jwt
      'Target-Domain': targetDomain,
    },
  });

  if (res.status === 500) {
    return;
  } else if (res.status === 401) {
    clearTokens();
    // avoid flickering
    if (!location.pathname.includes('/auth/login')) {
      location.href = '/auth/login';
    }
    return;
  } else if (!res.ok) {
    return;
  }

  const body = await res.json();

  if (body.error === 'logged_out') {
    clearTokens();
    // avoid flickering
    if (!location.pathname.includes('/auth/login')) {
      location.href = '/auth/login';
    }
    return;
  }

  const { jwt } = body;
  setJwt(jwt);
  return jwt;
}
